import React from 'react';
import _ from 'lodash';

const { Customer, Order } = Mobi2Go;
const className = Mobi2Go.helpers.classNames;

export default class Reward extends React.Component {
    constructor() {
        super();

        this.state = {
            reward: null,
            has_removed_reward: false,
        };

        Order.bind({
            updateId: () => {
                this.setState({ has_removed_reward: false });
                this.autoSetReward();
            },
            updateReward: reward => this.setState({ reward }),
            updateAvailableRewards: this.autoSetReward,
        });
    }

    /**
     * Automatically apply the first available reward
     * This logic should be moved into the core Order API when desktop UI
     * supports customer rewards.
     */

    autoSetReward = () => {
        if (this.state.has_removed_reward) {
            return;
        }

        if (Order.getProgressPhase() !== 'unconfirmed') {
            return;
        }

        if (Order.getVoucherApplied()) {
            return;
        }

        if (Order.getReward()) {
            return;
        }

        if (Customer.getLoyalty('DataCandyLoyalty')) {
            return;
        }

        if (Customer.getLoyalty('SpoonityLoyalty')) {
            return;
        }

        if (Customer.getLoyalty('ComoLoyalty')) {
            return;
        }

        const available_rewards = Order.getAvailableRewards();
        if (available_rewards.length) {
            // `setReward` will trigger another `updateAvailableRewards` event
            // So we must defer to ensure other listeners are fired in the right order
            _.defer(() => Order.setReward(available_rewards[0]));
        }
    };

    onRemoveClick = () => {
        this.setState({ has_removed_reward: true }, () => {
            Order.setReward(null);
        });
    };

    render() {
        const base_class = 'm2g-order-reward';
        const { reward } = this.state;
        if (!reward) {
            return null;
        }

        return (
            <div className={className('m2g-order-item m2g-order-reward')}>
                <div
                    className={className(
                        'm2g-order-reward-icon',
                        'm2g-icon',
                        'm2g-icon--gift'
                    )}
                />
                <div className="m2g-order-reward-title">
                    {this.state.reward.title}
                </div>
                <div
                    className="m2g-order-reward-remove m2g-icon m2g-icon--cross"
                    onClick={this.onRemoveClick}
                />
            </div>
        );
    }
}
